import { type } from 'arktype'

export const frRcpwSegments = ['AUTO', 'BIE', 'COM', 'MAC', 'MAN', 'MED', 'MISC', 'SECU', 'TECH'] as const
export const frRcpwSegmentsSchema = type('===', ...frRcpwSegments)
export type FrRcpwSegment = typeof frRcpwSegmentsSchema.infer

export const frRcpwSubSegments = ['BORLOO'] as const
export const frRcpwSubSegmentsSchema = type('===', ...frRcpwSubSegments)
export type FrRcpwSubSegment = typeof frRcpwSubSegmentsSchema.infer

export const frRcpwActivityClauses = [
  'transportGoods',
  'courtierTravaux',
  'locationVehicules',
  'conseilDecoration',
  'salleDanse',
  'gardeAnimaux',
  'comiteEntreprise',
] as const
export const frRcpwActivityClausesSchema = type('===', ...frRcpwActivityClauses)
export type FrRcpwActivityClause = typeof frRcpwActivityClausesSchema.infer

export const frRcpwActivityConfigurationSchema = type({
  wakamLabel: 'string',
  segment: frRcpwSegmentsSchema,
  'subSegment?': frRcpwSubSegmentsSchema.or(type.null),
  'specificClauses?': frRcpwActivityClausesSchema.array().or(type.null),
})

export type FrRcpwActivityConfiguration = typeof frRcpwActivityConfigurationSchema.infer

/**
 * A subscription is expected to hold a single fr-rcpw segment so the segment
 * is derived from the first activity configuration
 */
export function getFrRcpwSegmentFromActivitiesConfigurations(
  activitiesConfigurations: readonly FrRcpwActivityConfiguration[] | null | undefined,
): FrRcpwSegment | undefined {
  return activitiesConfigurations?.[0]?.segment
}

export function hasFrRcpwActivitySubSegment(
  activitiesConfigurations: readonly Pick<FrRcpwActivityConfiguration, 'subSegment'>[] | null | undefined,
  subSegment: FrRcpwSubSegment,
): boolean {
  return activitiesConfigurations?.some((configuration) => configuration.subSegment === subSegment) ?? false
}

export function getFrRcpwActivityClauses(
  activitiesConfigurations: readonly Pick<FrRcpwActivityConfiguration, 'specificClauses'>[] | null | undefined,
): FrRcpwActivityClause[] {
  const clauses = new Set<FrRcpwActivityClause>()
  for (const configuration of activitiesConfigurations ?? []) {
    for (const clause of configuration.specificClauses ?? []) clauses.add(clause)
  }
  return [...clauses]
}
